import { userLogout } from "../user-redux/action";

let sessionTimer;

const SESSION_TIMEOUT = 60 * 60 * 1000;

export const startSessionTimer = () => {
  localStorage.setItem("sessionStartTime", Date.now());

  if (sessionTimer) {
    clearTimeout(sessionTimer);
  }

  sessionTimer = setTimeout(() => {}, SESSION_TIMEOUT);
};

export const resetSessionTimer = () => {
  localStorage.setItem("sessionStartTime", Date.now());

  if (sessionTimer) {
    clearTimeout(sessionTimer);
  }

  sessionTimer = setTimeout(() => {}, SESSION_TIMEOUT);
};

export const checkSessionTimeout = (dispatch, user) => {
  const sessionStartTime = localStorage.getItem("sessionStartTime");

  if (!sessionStartTime) return; // Session not started
  const elapsedTime = Date.now() - parseInt(sessionStartTime, 10);
  if (elapsedTime > SESSION_TIMEOUT) {
    // Session expired
    dispatch(userLogout({ userid: user.id }));
  }
};
